import { W as WuiDateInput$1, d as defineCustomElement$1 } from './p-CDP3btmt.js';

const WuiDateInput = WuiDateInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateInput, defineCustomElement };
